<template>
    <div>
      <StitchRuleCard
          :allRules="allRules"
          :ruleIndex="ruleIndex"
          :crmInfo="crmInfo"
          :error="error"
          :objectOptions="objectOptions"
          :fieldOpt="fieldOpt"
          :crmName="crmName"
          :crmDefault="crmDefault"
          :currencyOpt="currencyOpt"
          :eventDateOpt="eventDateOpt"
          :dimensionOpt="fieldOpt"
          :simpleSoqlResponse="simpleSoqlResponse"
          :selectEvar="selectEvar"
          :selectEvent="selectEvent"
          :optionEvars="optionEvars"
          :optionEvents="optionEvents"
          :isLoadingEvar="isLoadingEvar"
          :isLoadingEvent="isLoadingEvent"
          :saveResponse = "saveResponse"
          :showCrmEdit="showCrmEdit"
          @objectUpdate="getfields"
          @deleteRule="deleteRule"
          @simpleSOQLCheck="simpleSOQLCheck"
          @saveData="saveData">
      </StitchRuleCard>
    </div>
  </template>

<script>
import rulesApi from '@/api/Stitcher/rules.js'
import CrmConnections from '@/api/CRM/CrmConnections.js'
import AnalyticsReports from '@/api/Analytics/AnalyticsReport.js'
import StitchRuleCard from '@/components/StitchRuleCard.vue'

export default {
  components: {
    StitchRuleCard
  },
  props: {
    allRules: {
      type: Object
    },
    ruleIndex: {
      type: Number
    },
    crmInfo: {
      type: Array
    }
  },
  data () {
    return {
      showCrmEdit: true,
      editObject: true,
      widgetIsOpen: false,
      isLoadingEvar: false,
      isLoadingEvent: false,
      check: true,
      currency: false,
      selectAndOr: { 'name': 'All', 'value': 'and' },
      selectEvar: { 'id': '', 'name': '' },
      selectEvent: { 'id': '', 'name': '' },
      selectCurrencyField: '',
      select_adobe_connection: '',
      simpleSoqlResponse: '',
      crmDefault: { 'crm_connection_id': '', 'type': '' },
      crmName: '',
      entity: '',
      error: {
        conditions: []
      },
      optionAndOr: [{ 'name': 'All', 'value': 'and' }, { 'name': 'Any', 'value': 'or' }],
      objectOptions: [],
      optionEvars: [],
      optionEvents: [],
      fieldOpt: [],
      currencyOpt: [],
      eventDateOpt: [],
      dismissSecs: 10,
      dismissCountDown: 0,
      saveResponse: ''
    }
  },
  computed: {
    conditionError () {
      return this.error.conditions
    },
    soqlError () {
      return this.error.soql
    },
    aaConnection () {
      return this.$store.state.data.AnalyticsData
    }
  },
  created () {
    this.setAllOptions()
    this.findDefaultCRM()
    this.getfields()
    this.getCrmObject()
  },
  methods: {
    saveData () {
      this.allRules.adobe_connection_id = this.select_adobe_connection
      var isValid = this.validationCheck(this.allRules)
      if (isValid) {
        this.error = {
          conditions: []
        }
        if (this.allRules.new) {
          this.allRules.new = false
        }
        if (this.allRules.rule_type === 'SIMPLE') {
          rulesApi.postSimpleRule(this.allRules)
            .then(response => {
              this.$emit('save', response.status)
              this.saveResponse = response.status
            })
        }
      }
    },
    validationCheck (rule) {
      var check = this.check
      if (!rule.name) {
        this.error.name = 'name is required'
        check = false
      }
      if (!rule.crm_connection_id) {
        if (!this.showCrmEdit) {
          rule.crm_connection_id = this.crmInfo.crm_connection_id
        } else {
          this.error.connection = 'Connection must be selected'
          check = false
        }
      }
      if (!rule.crm_object && !rule.rule_type === 'SOQL') {
        this.error.crm_object = 'CRM must be selected'
        check = false
      }
      if (!rule.adobe_connection_id) {
        this.error.adobe_connection_id = 'Connection must be selected'
      }
      if (!rule.adobe_variable) {
        this.error.adobe_variable = 'Adobe Analytics eVar must be selected'
        check = false
      } else {
        this.error.adobe_variable = ''
      }
      if (!rule.adobe_event) {
        this.error.adobe_event = 'Adobe Analytics Event must be selected'
        check = false
      } else {
        this.error.adobe_event = ''
      }

      if (rule.rule_type === 'SIMPLE') {
        if (!rule.and_or) {
          this.error.and_or = 'Type must be selected'
          check = false
        }
        var index = 0
        this.error.conditions.splice(0, rule.conditions.length)
        rule.conditions.forEach(condition => {
          var value = this.ruleValueType(condition.value, condition.operator)
          condition.value = value
          this.error.conditions.push({})
          if (!condition.field) {
            check = false
            this.error.conditions[index].field = 'Field must be selected'
          }
          if (!condition.operator) {
            check = false
            this.error.conditions[index].operator = 'Operator must be selected'
          }
          index = index + 1
        })
      }
      return check
    },
    simpleSOQLCheck () {
      var data = {
        'crm_connection_id': this.allRules.crm_connection_id,
        'conditions': this.allRules.conditions,
        'crm_object': this.allRules.crm_object,
        'and_or': this.allRules.and_or,
        'revenue_field': this.allRules.revenue_field ? this.allRules.revenue_field : null,
        'entity': this.entity
      }
      this.dismissCountDown = 0
      rulesApi.simpleSoqlValidDynamics(data)
        .then(response => {
          if (response.error) {
            this.simpleSoqlResponse = `error : ${response.error} `
          } else {
            if (response.status === 'Invalid SOQL') {
              this.simpleSoqlResponse = `Status: ${response.status}`
            } else {
              this.simpleSoqlResponse = `Number of records: ${response.number_of_records}, Status: ${response.status}`
            }
          }
          this.showAlert()
        })
    },
    ruleValueType (value, operator) {
      var isNumber = Number(value)
      if (!isNaN(isNumber)) {
        return isNumber
      } else {
        return value
      }
    },
    crmInput () {
      this.allRules.crm_connection_id = parseInt(this.crmDefault.crm_connection_id)
      var selectCrm = this.crmInfo.find(crm => crm.crm_connection_id === this.crmDefault.crm_connection_id)
      this.crmName = selectCrm.company_name
      this.getCrmObject()
      this.getfields()
    },
    setAllOptions () {
      this.isLoadingEvar = true
      this.isLoadingEvent = true
      if (!this.select_adobe_connection && this.aaConnection[0]) {
        this.select_adobe_connection = this.aaConnection[0].adobe_connection_id
      }
      AnalyticsReports.getevars(this.select_adobe_connection)
        .then(response => {
          this.optionEvars = response
          this.selectEvar.id = this.allRules.adobe_variable
          this.isLoadingEvar = false
        })
      AnalyticsReports.getEvents(this.select_adobe_connection)
        .then(response => {
          this.optionEvents = response
          this.selectEvent.id = this.allRules.adobe_event
          this.isLoadingEvent = false
        })
    },
    cancel () {
      // TODO: look and see what is going on with this.
      this.$emit('cancel', this.ruleIndex)
      this.error = {
        conditions: []
      }
    },
    deleteCondition (conditionIndex) {
      this.allRules.conditions.splice(conditionIndex, 1)
      this.$store.commit('updateRule', { 'ruleIndex': this.ruleIndex, 'rule': this.allRules })
    },
    getfields () {
      if (this.allRules.rule_type === 'SIMPLE') {
        if (!this.allRules.crm_connection_id) {
          if (this.crmDefault.crm_connection_id) {
            this.allRules.crm_connection_id = parseInt(this.crmDefault.crm_connection_id)
          } else {
            if (this.crmInput && this.crmInput.length > 0) {
              this.crmDefault = this.crmInfo[0]
              this.allRules.crm_connection_id = parseInt(this.crmDefault.crm_connection_id)
            }
          }
        }
        if (!this.allRules.crm_object) {
          this.allRules.crm_object = 'lead'
        }
        if (this.allRules.crm_connection_id) {
          CrmConnections.getDynamicsFields(this.allRules.crm_object, this.allRules.crm_connection_id)
            .then(response => {
              this.fieldOpt = []
              this.fieldOpt = response.fields
              this.entity = response.entity

              this.currencyOpt = this.fieldOpt.filter(function (field) {
                return field.type === 'currency'
              })
              this.eventDateOpt = this.fieldOpt.filter(function (field) {
                switch(field.type) {
                  case 'date':
                    return field.type
                  case 'datetime':
                    return field.type
                }
              })
            })
        }
      }
    },
    findDefaultCRM () {
      this.selectAndOr.value = this.allRules.and_or
      this.selectCurrencyField = this.allRules.revenue_field
      if (this.allRules.event_type === 'currency') {
        this.currency = true
      } else {
        this.currency = false
      }
      if (this.crmInfo.length <= 1) {
        this.crmDefault = this.crmInfo[0]
        this.crmName = this.crmInfo[0].company_name
        this.crmDefault.crm_connection_id = this.crmInfo[0].crm_connection_id.toString()
        this.showCrmEdit = false
      } else {
        this.showCrmEdit = true
        if (this.allRules.crm_connection_id !== null) {
          this.crmInfo.forEach(crm => {
            if (this.allRules.crm_connection_id === parseInt(crm.crm_connection_id)) {
              this.crmDefault.crm_connection_id = this.allRules.crm_connection_id
              this.crmName = crm.company_name
              this.crmDefault.type = crm.type
            }
          })
        }
      }
    },
    getCrmObject () {
      if (!this.allRules.crm_connection_id && this.crmInfo.length <= 1) {
        this.allRules.crm_connection_id = this.crmInfo[0].crm_connection_id
      }
      CrmConnections.getDynamicsObject(this.allRules.crm_connection_id)
        .then(response => {
          this.objectOptions = response
          return response
        })
    },
    deleteRule () {
      this.$emit('delete')
    }
  }
}
</script>
